import * as api from './client-devtool';

window.Ya = window.Ya || {};
window.Ya.Divkit = window.Ya.DivKit = api;
